/**
 * 阅读器支付弹窗颜色配置（PC 侧独立实现，不依赖 H5 i18n 系统）
 * 数据来源：H5 src/composables/payment/configs/brands/{brand}/chapter.colors
 */
import { loadBrandConfig } from '@/utils/loadBrandConfig'

export interface ChapterPayColors {
  memberSubscribeBg: string
  subscribeActiveBg: string
}

const rocnovelColors: ChapterPayColors = {
  memberSubscribeBg: '/images/rocnovel/chapter/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

const ocereadColors: ChapterPayColors = {
  memberSubscribeBg: '/images/oceread/chapter/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

const ficmoonColors: ChapterPayColors = {
  memberSubscribeBg: '/images/ficmoon/chapter/member_subscribe_bg.webp',
  subscribeActiveBg: '#2C2A28',
}

const novelarcColors: ChapterPayColors = {
  memberSubscribeBg: '/images/novelarc/chapter/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

const storyellaColors: ChapterPayColors = {
  memberSubscribeBg: '/images/storyella/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

const silktaleColors: ChapterPayColors = {
  memberSubscribeBg: '/images/silktale/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

const pearlaColors: ChapterPayColors = {
  memberSubscribeBg: '/images/pearla/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

const fictoraColors: ChapterPayColors = {
  memberSubscribeBg: '/images/fictora/member_subscribe_bg.webp',
  subscribeActiveBg: '#2C2A28',
}

const marinovelColors: ChapterPayColors = {
  memberSubscribeBg: '/images/marinovel/member_subscribe_bg.webp',
  subscribeActiveBg: '#F3F5FA',
}

export function getChapterPayColors(): ChapterPayColors {
  return loadBrandConfig({
    rocnovel: rocnovelColors,
    oceread: ocereadColors,
    ficmoon: ficmoonColors,
    novelarc: novelarcColors,
    storyella: storyellaColors,
    silktale: silktaleColors,
    pearla: pearlaColors,
    fictora: fictoraColors,
    marinovel: marinovelColors,
  })
}
